interface BarProps {
  progress: number;
  height?: number;
  backgroundColor?: string;
  progressColor?: string;
  className?: string;
}

const Bar = ({
  progress, 
  height = 13,
  backgroundColor = '#F8F5EE',
  progressColor = '#42C52D',
  className = ''
}: BarProps) => {
  return (
    <div 
      className={`relative rounded-full ${className}`}
      style={{ 
        backgroundColor,
        height: `${height}px`
      }}
    >
      <div 
        className="h-full rounded-full flex justify-center items-center overflow-hidden transition-all duration-500 ease-out" 
        style={{ 
          backgroundColor: progressColor,
          width: `${progress * 100}%`,
        }}
      >
      </div>
    </div>
  )
}

export default Bar;